<template>
	<section id="juniperStatistics" class="jc-view">
		<JuniperPageHeader back="/juniper" title="Statistics" subtitle="Cross-client insights for Juniper CMS" />

		<!-- Tab registry lives in `tabs` — add an entry + a component below to grow the page. -->
		<ul class="nav nav-tabs mt-3" role="tablist">
			<li v-for="tab in tabs" :key="tab.key" class="nav-item" role="presentation">
				<button
					class="nav-link"
					:class="{ active: activeTab === tab.key }"
					type="button"
					@click="selectTab(tab.key)"
				>
					<i :class="tab.icon + ' me-1'"></i> {{ tab.label }}
				</button>
			</li>
		</ul>

		<div class="js-tab-content mt-3">
			<UnifiedDashboardStats v-if="activeTab === 'unified-dashboard'" />
		</div>
	</section>
</template>

<script>
import UnifiedDashboardStats from '@/components/juniper/statistics/UnifiedDashboardStats.vue'

const TABS = [
	{ key: 'unified-dashboard', label: 'Unified Dashboard', icon: 'fas fa-columns' },
]

export default {
	name: 'JuniperStatistics',
	components: { UnifiedDashboardStats },
	data() {
		return {
			tabs: TABS,
			activeTab: this.resolveTab(this.$route.query.tab),
		}
	},
	watch: {
		'$route.query.tab'(value) {
			this.activeTab = this.resolveTab(value)
		},
	},
	methods: {
		resolveTab(value) {
			return TABS.some(t => t.key === value) ? value : TABS[0].key
		},
		// Tab lives in the URL (?tab=…) so a filtered view can be shared/bookmarked.
		selectTab(key) {
			if (key === this.activeTab) return
			this.$router.replace({ query: { ...this.$route.query, tab: key } })
		},
	},
}
</script>

<style scoped>
#juniperStatistics {
	margin-top: 0 !important;
	padding-bottom: 40px;
}

.jc-view {
	width: 100%;
}
</style>
